// extracted by mini-css-extract-plugin
export default {"root":"NrgLwgvgNSntdIkf4NeD","text":"_SIGcbNozINfdbzUDcPr","sign":"Ec_dEPs1YYUoH023eKhc","h1":"iLXzru2TMON_CQBBpeJO","placeHolderShimmer":"AM5IPHtP38Ev0lkm2NlD"};